import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex } from '../../../models/enums';
import { ExportDb, ExportDbViewModel } from '../../../models/export-database';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { NameDescriptionComponent } from '../../name-description/name-description.component';
import { DrObjectType, SupportedRegExType, DrObject } from '../../../models/dr-object';

@Component({
    standalone: false,
    selector: 'res-new-export-database-modal',
    templateUrl: './new-export-database-modal.component.html',
    styleUrls: ['./new-export-database-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NewExportDatabaseModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild('contentForm', { static: true }) contentForm: NgForm;
    @ViewChild(NameDescriptionComponent, { static: true }) nameDescriptionComponent: NameDescriptionComponent;

    isBusy = false;
    isBusyMessage = 'Loading...';
    modalAutomationId = 'new-export-database-modal';
    modalTitle = 'New Export Database';
    secondaryButtonLabel = 'Cancel';
    primaryButtonLabel = 'OK';
    modalClass = 'new-export-database-modal';
    modalHelpIndex = HelpIndex.add_edit_org_export_db_dlg;
    exportDb: ExportDb;
    isInEditMode: boolean;

    validateNameRequest = {
        endpoint: Endpoint.viewManager_validateName,
        request: (name) => {
            return {
                name: this.nameDescriptionComponent.name,
                organizationName: this.commonService?.currentUser?.customerName,
                objectType: DrObjectType.EXPORT_CONNECTION
            };
        }
    };

    constructor(private modalService: BsModalService,
        private restService: RestService,
        private commonService: CommonService,
        private modalRef: BsModalRef) {
        super(modalService, modalRef);
    }

    ngOnInit() {

        if (this.modalData) {
            this.exportDb = this.modalData;
            this.modalTitle = 'Edit Export Database';
            this.isInEditMode = true;
        } else {
            this.exportDb = new ExportDb();
        }

        this.nameDescriptionComponent.drObject = new ExportDbViewModel(this.exportDb);
    }

    isPrimaryButtonEnabled(): boolean {
        let enabled = false;
        if (this.nameDescriptionComponent.formValid) {
            enabled = (this.contentForm.valid && this.nameDescriptionComponent.formValid);
        }
        return enabled;
    }

    isValidateEnabled(): boolean {
        return this.contentForm.valid;
    }

    validate(): void {
        if (this.exportDb) {
            this.isBusy = true;
            this.isBusyMessage = 'Validating ...';
            const requestData = {
                databaseName: this.exportDb.databaseName,
                ipAddress: this.exportDb.ipAddress,
                port: this.exportDb.port,
                type: this.exportDb.type,
                username: this.exportDb.username,
                password: this.exportDb.password
            };
            this.restService.post(Endpoint.orgManager_validateExportDatabaseConnection, requestData).then(response => {
                this.isBusy = false;
                if (response.valid) {
                    this.commonService.openInformationToastNotification('Export Database Connection is valid');
                }
            }, error => {
                this.isBusy = false;
            });
        }
    }

    save(): void {
        if (this.exportDb) {
            this.isBusy = true;
            this.isBusyMessage = 'Saving ...';
            if (this.isInEditMode) {
                const requestData = {
                    handle: this.exportDb.handle,
                    description: this.nameDescriptionComponent.description,
                    databaseName: this.exportDb.databaseName,
                    ipAddress: this.exportDb.ipAddress,
                    port: this.exportDb.port,
                    type: this.exportDb.type,
                    username: this.exportDb.username,
                    password: this.exportDb.password
                };
                this.restService.post(Endpoint.orgManager_updateExportDatabaseConnection, requestData).then(response => {
                    this.isBusy = false;
                    this.closeModal(true);
                }, error => {
                    this.isBusy = false;
                });
            } else {
                // uncomment this when name validation will be implemented at ST side
                // this.nameDescriptionComponent.validate().then(valid => {
                //     if (valid) {
                this.exportDb.name = this.nameDescriptionComponent.name;
                this.exportDb.description = this.nameDescriptionComponent.description;
                this.restService.post(Endpoint.orgManager_createExportDatabaseConnection, this.exportDb).then(response => {
                    this.isBusy = false;
                    this.closeModal(true);
                }, error => {
                    this.isBusy = false;
                });
                // } else {
                //     this.isBusy = false;
                // }
                // });
            }
        }
    }
}
